import makeStyles from '@mui/styles/makeStyles';

const drawerWidth = '15rem';
const collapsedDrawerWidth = '4rem';

export const useStyles = makeStyles((theme) => ({
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(0, 1),
    background: theme.palette.baseColors.deepSeaNavy.c100,
    ...theme.mixins.toolbar,

    '& > a': {
      width: '100%',
      maxHeight: '2rem',
      display: 'flex',
      justifyContent: 'center',
      margin: '0 auto',
      color: theme.palette.baseColors.offWhite.c100,
    },
  },

  drawer: {
    position: 'relative',
    flexShrink: 0,
    whiteSpace: 'nowrap',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    '& .MuiDrawer-paper': {
      background: theme.palette.baseColors.deepSeaNavy.c100,
      color: theme.palette.baseColors.offWhite.c100,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
  },

  drawerOpen: {
    width: drawerWidth,
    '& .MuiDrawer-paper': {
      width: drawerWidth,
    },
  },

  drawerClosed: {
    width: collapsedDrawerWidth,
    transition: theme.transitions.create('width', {
      duration: theme.transitions.duration.leavingScreen,
    }),
    '& .MuiDrawer-paper': {
      width: collapsedDrawerWidth,
      transition: theme.transitions.create('width', {
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
  },

  toggleButton: {
    display: 'grid',
    width: '100%',
    color: theme.palette.baseColors.offWhite.c100,
    placeContent: 'center',
    '& > svg': {
      transition: 'transform 0.2s ease',
    },
    '&:hover svg': {
      translate: '-0.2rem 0 0',
    },
  },

  listItemButtonToggle: {
    marginTop: '0.5rem',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: `${theme.palette.baseColors.black.c100}50`,
  },

  listItemIconSelected: {
    color: theme.palette.baseColors.offWhite.c100,
  },

  listItemIconUnselected: {
    color: theme.palette.baseColors.white.c25,
  },

  listItem: {
    display: 'block',
    minHeight: '2.75rem',
    '&:hover': {
      backgroundColor: `${theme.palette.baseColors.black.c100}50`,
    },
  },

  listItemButton: {
    display: 'flex',
    justifyContent: 'initial',
    textDecoration: 'none',
    color: 'inherit',
  },

  listItemButtonDisabled: {
    opacity: 0.5,
  },

  navLink: {
    display: 'flex',
    justifyContent: 'initial',
    alignItems: 'center',
    textDecoration: 'none',
    color: 'inherit',
    padding: '0.5rem 1rem',
    minHeight: '2.75rem',
    transition: theme.transitions.create(['background-color'], {
      duration: theme.transitions.duration.short,
    }),
    '&:hover': {
      backgroundColor: `${theme.palette.baseColors.black.c100}50`,
    },
  },
}));
